import styled from 'styled-components'
import { paragraph } from 'styles/typography'
import mq from 'styles/mq'
import theme from 'styles/theme'

export const ReviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  min-height: 10rem;
  padding: 2rem 0;
  border-bottom: 0.1rem solid ${theme.color.text.dark};

  ${mq.medium} {
    flex-direction: row;
    padding: 4rem 0;
  }
`
export const ReviewQuote = styled.div`
  ${paragraph.normal};
  letter-spacing: 0.02em;
  margin-bottom: 4rem;

  ${mq.medium} {
    max-width: 40rem;
    margin-bottom: 0;
  }

  ${mq.large} {
    max-width: 50rem;
  }
`

export const ReviewQuoteText = styled.div`
  margin-bottom: 2rem;
`

export const ReviewQuoteSource = styled.div`
  color: ${theme.color.text.gray};
`

export const ReviewInfo = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  ${mq.medium} {
    width: inherit;
    display: block;
    text-align: right;
  }
`

export const ReviewStars = styled.div`
  display: flex;

  ${mq.medium} {
    display: block;
    margin-bottom: 2rem;
  }
`

export const ReviewDate = styled.div`
  display: flex;

  ${mq.medium} {
    display: block;
  }
`